import { render, staticRenderFns } from "./WaferBoxLabelDialog.vue?vue&type=template&id=bb28e478&scoped=true"
import script from "./WaferBoxLabelDialog.vue?vue&type=script&lang=js"
export * from "./WaferBoxLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./WaferBoxLabelDialog.vue?vue&type=style&index=0&id=bb28e478&prod&scoped=true&lang=css"
import style1 from "./WaferBoxLabelDialog.vue?vue&type=style&index=1&id=bb28e478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb28e478",
  null
  
)

export default component.exports